import type { PlatformType } from '../types/platform';

export type ActionMode = 'standard' | 'interview' | 'event';

/**
 * Discriminates the UI/validation behavior for an Action based on its exact
 * (platform, type) pair. Strictly gated so existing action types (and Change A
 * types) are never affected.
 */
export function getActionMode(
  platform: PlatformType | string,
  type: string,
): ActionMode {
  if (platform === 'Youtube' && type === 'Interview') return 'interview';
  if (
    platform === 'Event' &&
    (type === 'Talk' || type === 'Sponsor' || type === 'Attendance')
  )
    return 'event';
  return 'standard';
}

export const hasNoValidation = (
  platform: PlatformType | string,
  type: string,
): boolean => getActionMode(platform, type) !== 'standard';
